import { object, array } from 'zod';

import { makeZodValidate as makeValidate } from '@occc/ui-forms';

const USER_REQUIRED = 'Please select at least one user';
const LOCATION_GROUP_REQUIRED = 'Please select at least one location group';

const schema = object({
  users: array(object({}), { required_error: USER_REQUIRED }).min(1, USER_REQUIRED),
  locationGroups: array(object({}), { required_error: LOCATION_GROUP_REQUIRED }).min(
    1,
    LOCATION_GROUP_REQUIRED,
  ),
});

export const validate = makeValidate(schema);
